import styles from "./CompletableChecklistItem.module.css";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import { useCallback, useId } from "react";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";

type CompletableChecklistItemProps = {
  title: string;
  completed: boolean;
  onCompletedChange: (newCompleted: boolean) => void;
  disabled: boolean;
};

function CompletableChecklistItem({
  title,
  completed,
  onCompletedChange,
  disabled,
}: CompletableChecklistItemProps) {
  const id = useId();

  const handleChange = useCallback(() => {
    onCompletedChange(!completed);
  }, [completed, onCompletedChange]);

  return (
    <li className={completed ? styles["completed"] : styles["uncompleted"]}>
      <FixaCheckbox
        id={id}
        value={id}
        checked={completed}
        onChange={handleChange}
        subtle
        disabled={disabled}
      />
      <FixaText textStyle="Body.M">{title}</FixaText>
    </li>
  );
}

export default CompletableChecklistItem;
